import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}
function AccordionItem({
  title,
  children,
  isOpen,
  onToggle
}: AccordionItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-7">
      <button className="w-full py-4 px-6 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors text-left" onClick={onToggle} aria-expanded={isOpen} data-id="element-8">
        <span className="text-lg font-bold text-gray-800" data-id="element-9">{title}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" aria-hidden="true" data-id="element-10" /> : <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" aria-hidden="true" data-id="element-11" />}
      </button>
      <div className={cn('overflow-hidden transition-all duration-300 ease-in-out', isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0')} data-id="element-12">
        <div className="p-6 pt-0 text-gray-600 leading-relaxed" data-id="element-13">{children}</div>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full border border-gray-200 rounded-lg shadow-sm bg-white divide-y divide-gray-200" data-id="element-14">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={openIndex === index} onToggle={() => handleToggle(index)} data-id="element-15">
          {item.content}
        </AccordionItem>)}
    </div>;
}
function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ');
}